import { ApplicationRef } from '@angular/core';
import { _MatTooltipBase, _TooltipComponentBase } from '@angular/material/tooltip';

export function patch(appRef: ApplicationRef) {
	matTooltipPatch(appRef);
}

function matTooltipPatch(appRef: ApplicationRef) {
	const showOrigin = _MatTooltipBase.prototype.show;
	const hideOrigin = _MatTooltipBase.prototype.hide;
	const _TooltipComponentBaseProto = _TooltipComponentBase.prototype as any;
	const _onShowOrigin = _TooltipComponentBaseProto._onShow;

	_MatTooltipBase.prototype.show = function show(...args: any[]) {
		showOrigin.call(this, ...args);
		// private method _onShow call sync
		setTimeout(() => {
			this._tooltipInstance?._changeDetectorRef.detectChanges();
		}, (this.showDelay || 0) + 1);
	};
	_MatTooltipBase.prototype.hide = function hide(...args: any[]) {
		hideOrigin.call(this, ...args);
		setTimeout(() => {
			this._tooltipInstance?._changeDetectorRef.detectChanges();
		}, (this.hideDelay || 0) + 1);
	};

	_TooltipComponentBaseProto._onShow = function _onShow() {
		_onShowOrigin.call(this);
		// setTimeout(() => this._tooltipInstance?._changeDetectorRef.detectChanges());
	};
}
